export default 'https://meme-api.teahouse.team'
// export default 'http://localhost:8000'
